import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

export interface TagListParams {
  page?: number;
  limit?: number;
  q?: string;
  verified?: boolean;
}

@Injectable({ providedIn: 'root' })
export class TagsService {
  constructor(private api: ApiService) {}

  list(params: TagListParams = {}): Promise<any> {
    const qs = new URLSearchParams();
    if (params.page) qs.set('page', String(params.page));
    if (params.limit) qs.set('limit', String(params.limit));
    if (params.q) qs.set('q', params.q);
    if (params.verified !== undefined) qs.set('verified', String(params.verified));
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return this.api.get(`/tag/list${suffix}`);
  }

  get(id: number): Promise<any> {
    return this.api.get(`/tag/${id}`);
  }

  create(payload: any): Promise<any> {
    return this.api.postJSON('/tag', payload);
  }

  update(id: number, payload: any): Promise<any> {
    return this.api.put(`/tag/${id}`, payload);
  }

  remove(id: number): Promise<any> {
    return this.api.delete(`/tag/${id}`);
  }

  getUsage(id: number): Promise<any> {
    return this.api.get(`/tag/${id}/usage`);
  }
}
